/**
 * The wizard's camera: the building alone at building zoom, or the building
 * AND every assembly point placed on the map, padded (Trav, 2026-09-30: a
 * reunification point a kilometre away was off screen). The span is a square
 * in degrees — the unit both map engines' focus takes — and never tighter
 * than the building-level frame.
 */

export const BUILDING_SPAN = 0.004;
/** Room around the outermost pins so none sits on the frame's edge. */
const PAD = 1.6;

export interface Frame {
  latitude: number;
  longitude: number;
  span: number;
}

export function frameFor(
  building: { latitude: number; longitude: number } | null,
  points: { latitude: number; longitude: number }[],
): Frame | null {
  const all = [...(building ? [building] : []), ...points];
  if (all.length === 0) return null;
  if (all.length === 1 || points.length === 0) {
    const only = building ?? all[0]!;
    return { latitude: only.latitude, longitude: only.longitude, span: BUILDING_SPAN };
  }
  let minLat = Infinity;
  let maxLat = -Infinity;
  let minLon = Infinity;
  let maxLon = -Infinity;
  for (const c of all) {
    minLat = Math.min(minLat, c.latitude);
    maxLat = Math.max(maxLat, c.latitude);
    minLon = Math.min(minLon, c.longitude);
    maxLon = Math.max(maxLon, c.longitude);
  }
  return {
    latitude: (minLat + maxLat) / 2,
    longitude: (minLon + maxLon) / 2,
    span: Math.max(BUILDING_SPAN, Math.max(maxLat - minLat, maxLon - minLon) * PAD),
  };
}
